import { AppHelper } from "../appHelper.js";
import { AppBaseProps, Entity, CommonApp, Context } from "../core/components/commonApp.js";
import { Warehouse } from "./stocks.js";
import { EditableGrid, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid.js";
import { ToolBarInGridButtonType } from "../core/components/toolBar.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { KeyValuePair } from "../commonInterfaces.js";
import { HTTPService } from "../core/util/httpManager.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DropDownList } from "../core/components/dropDownList.js";
import { Helper } from "../core/util/helper.js";
import { StocksService } from "./stocksService.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import React from "react";
export interface IncomingGoodsProps extends AppBaseProps {
    entity: IncomingGoodsEntity;
    context: IncomingGoodsContext;
}

interface IncomingGoodsContext extends Context {
    warehouses: Warehouse[];
    sourceTypes: KeyValuePair<number, string>[];
    stockTypes: KeyValuePair<number, string>[];
}

export interface IncomingGoodsEntity extends Entity {
    AdrNr: number;
    DeliveryBillId: string;

    ExecutedBy: string;
    ExtecutedAt: Date;

    Goods: Good[];

    Preselection: GoodPreselection;
}

interface GoodPreselection {
    WarehouseId: number;
    StorageSpaceId: number;
    Source: number;

    State: number;

    TargetAdrNr: string;
    ProjNr: string;
}

interface Good {
    Pos: number;

    ArtikelNr: number;
    ArticleNumber: string;
    Article: string;
    ChargenNr: string;
    SerienNr: string;

    Source: number;
    Anzahl: number;

    Lagerid: number;
    Lagerplatzid: number;
    State: number;

    Comment: string;

    ProjNr: string;
    TargetAdrNr: string;

    RawArticle?: any;
}
export default class IncomingGoods extends React.Component<IncomingGoodsProps, any>{
    private common = new AppHelper();
    private factory = ComponentHelper.createFactory();
    private gridColumns: GridColumn[];
    private warehouses: Warehouse[];
    constructor(props: IncomingGoodsProps) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        this.warehouses = props.context.warehouses;
        this.gridColumns = props.metadata.additional.objects.find(f => f.name == "gridColumns")?.data;
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Preselection.WarehouseId":
                this.handleFieldChange({ model: "entity.Preselection.StorageSpaceId" }, this.warehouses.find(w => w.Id == value).StorageSpaces[0].Id)
                break;
        }
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem, () => {
                if ((field.model != "entity.Goods") || (this.props.entity.Goods.length == 0)) {
                    this.common.setEntityDirtyState(false);
                }
            });
        }
            
    }

    renderGrid = () => {
        return <GoodsGrid
            goods={this.props.entity.Goods}
            onChange={(goods) => { this.handleFieldChange({ model: "entity.Goods" }, goods) }}
            preselection={this.props.entity.Preselection}
            warehouses={this.warehouses}
            sourceTypes={this.props.context.sourceTypes}
            stockTypes={this.props.context.stockTypes}
            gridColumns={this.gridColumns}
        />
    }

    renderDropDown = (field: string) => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = this.props.entity.Preselection[field];
        props.field.model = "entity.Preselection." + field
        props.field.refreshDSOnRefChange = true;
        props.field.optionLabel = "";
        props.onChange = this.handleFieldChange;

        switch (field) {
            case "StorageSpaceId":
                props.dataSource = this.warehouses.find(w => w.Id == this.props.entity.Preselection.WarehouseId).StorageSpaces;
                props.field.dataTextField = "Name";
                props.field.dataValueField = "Id";
                break;
            case "Source":
                props.dataSource = this.props.context.sourceTypes;
                props.field.dataTextField = "Value";
                props.field.dataValueField = "Key";
                break;
            case "State":
                props.dataSource = this.props.context.stockTypes;
                props.field.dataTextField = "Value";
                props.field.dataValueField = "Key";
                break;
        }

        return <DropDownList {...props} />
    }

    book = async () => {
        if(!this.common.validate())
            return

        const { Code, Message } = await StocksService.book(this.props.entity);
        if (Code == 0) {
            this.handleFieldChange({ model: "entity.Goods" }, []);
            const userWantToContinue: boolean = await DialogHelper.choose(Helper.getTranslation("WebSMS.Warehouse.IncomingGoods.Continue"), [{ label: Helper.getTranslation("Server.No"), value: false, primary: false }, { label: Helper.getTranslation("Server.Yes"), value: true, primary: true }]);
            if (!userWantToContinue) {
                this.common.sheetWrapper.hide();
            }
        } else {
            NotificationHelper.showErrorResult(Message)
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.getTranslation("WebSMS.Warehouse.IncomingGoods"));
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}
interface GoodsGridProps {
    warehouses: Warehouse[];
    sourceTypes: KeyValuePair<number, string>[];
    stockTypes: KeyValuePair<number, string>[];

    preselection: GoodPreselection;
    goods: Good[];
    onChange: (goods: Good[]) => void;
    gridColumns: GridColumn[];
}
class GoodsGrid extends React.Component<GoodsGridProps, any>{
    private gridOptions;
    private ADD_BTN_ID = "add";
    private DELETE_BTN_ID = "delete";
    private gridRef: EditableGrid;
    constructor(props: GoodsGridProps) {
        super(props);
        this.initApp();
    }

    private initApp = async () => {
        const gridColumns = this.props.gridColumns;
        for (let index = 0; index < gridColumns.length; index++) {
            switch (gridColumns[index].field) {
                case "articleMC":
                    for (let subIndex = 0; subIndex < gridColumns[index].columns.length; subIndex++) {
                        if (gridColumns[index].columns[subIndex].field == "Article") {
                            gridColumns[index].columns[subIndex].template = (good: Good) => {
                                return `<div class="truncate" title="${good.Article}">${good.Article}</div>`;
                            }
                        }
                    }
                    break;
                case "warehouseMC":
                    for (let subIndex = 0; subIndex < gridColumns[index].columns.length; subIndex++) {
                        switch (gridColumns[index].columns[subIndex].field) {
                            case "Lagerplatzid":
                                gridColumns[index].columns[subIndex].template = (good: Good) => {
                                    return this.props.warehouses.find(w => w.Id == good.Lagerid)?.StorageSpaces.find(s => s.Id == good.Lagerplatzid)?.Name ?? good.Lagerplatzid.toString();
                                }
                                break;
                        }
                    }
                    break;
            }
        }


        this.gridOptions = {
            columns: gridColumns
        }
    }

    private onDataChange = (action, fieldName, dataItems: any[]) => {
        if (action != "itemchange" && fieldName != "result")
            return;
        const goods = this.props.goods;
        const index = goods.findIndex(good => good.Pos == dataItems[0].Pos)
        switch (fieldName) {
            case "Lagerid":
                const warehouse = parseInt(dataItems[0].Lagerid.toString());
                const storageSpace = this.props.warehouses.find(w => w.Id == parseInt(dataItems[0].Lagerid.toString())).StorageSpaces[0].Id;
                dataItems[0].set("Lagerplatzid", storageSpace);
                goods[index].Lagerid = warehouse;
                goods[index].Lagerplatzid = storageSpace;
                break;
            default:
                goods[index][fieldName] = dataItems[0][fieldName]
                break;
        }
        this.props.onChange(goods);
        
    }

    private handleButtonClick = async (p: InGridButtonClickParams) => {
        let goods: Good[] = [];
        switch (p.id) {
            case this.ADD_BTN_ID:
                goods = await this.createGoods();
                p.actions.addBulk(goods);
                break;
            case this.DELETE_BTN_ID:
                const tmp = p.selectedItems.map(g => g.Pos)
                goods = this.props.goods;
                goods = goods.filter(g => tmp.indexOf(g.Pos) == -1)
                p.actions.deleteSelected(false);
                for (let i = 0; i < goods.length; i++) {
                    goods[i].Pos = i + 1;
                }
                break;
        }
        this.props.onChange(goods);
        this.gridRef.forceUpdate();
    }

    private createGoods = () => {
        return new Promise<Good[]>((resolve) => {
            const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Parts?multi=true&displayPattern=[[bezeichnung]]");
            sheet.bind(SheetEventType.ItemsSelected, async (e: { data: any[] }) => {
                const goods = this.props.goods;
                let pos = goods.length;
                e.data.forEach((article) => {
                    pos += 1;
                    goods.push({
                        Pos: pos,
                        Article: article.bezeichnung,
                        ArticleNumber: article.artikelnummer,
                        ArtikelNr: article.artnr,
                        ChargenNr: "-",
                        SerienNr: "-",
                        Comment: "",
                        ProjNr: this.props.preselection.ProjNr,
                        Source: this.props.preselection.Source,
                        Lagerplatzid: this.props.preselection.StorageSpaceId,
                        Lagerid: this.props.preselection.WarehouseId,
                        TargetAdrNr: this.props.preselection.TargetAdrNr,
                        State: this.props.preselection.State,
                        Anzahl: 1,
                        RawArticle: article
                    });
                });
                document.title = Helper.getPageTitle();
                resolve(goods)
            })
        })
    }

    render() {
        const someId = "IncomingGoods";

        let schema = new Schema();
        schema.Id = someId;

        const warehouses = this.props.warehouses.filter(f => f.StorageSpaces.length > 0)

        const whatever: any = {
            ...this.props,
            dataSources: {
                types: this.props.sourceTypes,
                warehouses: warehouses,
                states: this.props.stockTypes
            }
        };

        const buttons: Array<InGridToolBarButton> = [
            { type: ToolBarInGridButtonType.NEW, id: this.ADD_BTN_ID, caption: Helper.getTranslation("WebSMS.Warehouse.IncomingGoods.AddParts") },
            { type: ToolBarInGridButtonType.DELETE, id: this.DELETE_BTN_ID }
        ];

        return (
            <div style={{ height: "550px" }}>
                <EditableGrid data={this.props.goods}
                    id={someId}
                    schema={schema}
                    gridOptions={this.gridOptions}
                    editable={true}
                    onDataChanged={this.onDataChange}
                    validatable={false}
                    groupable={false}
                    filterable={false}
                    buttons={buttons}
                    onButtonClick={this.handleButtonClick}
                    ref={(ref) => {this.gridRef = ref } }
                    {...whatever}
                />
            </div>
        )
    }
}
interface GridColumn {
    field: string;
    template?: (good: Good) => string;
    columns?: GridColumn[];
}